module.exports = __webpack_public_path__ + "img/checklist-modal-icon.8653da78.svg";